module.exports = __webpack_public_path__ + "static/media/ProfessionalRoadmap.76be009f.svg";